//#region src/schema/localization/locales/de.ts
var e = {
	schema: {
		variants: "Varianten",
		discriminatorValue: "Diskriminatorwert",
		noAllowedValues: "Keine Werte erfüllen diese Enum-Bedingung.",
		example: "Beispiel",
		examples: "Beispiele",
		default: "Standard",
		schema: "Schema",
		emptyObject: "Leeres Objekt",
		showAdditionalProperties: "Zusätzliche Eigenschaften anzeigen",
		showOneMoreProperty: "1 weitere Eigenschaft anzeigen",
		showMoreProperties: "{count} weitere Eigenschaften anzeigen",
		forName: "für {name}",
		showSchemaDetails: "Schema-Details anzeigen",
		oneOf: "Eines von",
		anyOf: "Beliebiges von",
		allOf: "Alle von",
		not: "Nicht",
		unknownType: "unbekannter Typ",
		propertyCount: "Eigenschaften: {count}",
		headerCount: "Header: {count}",
		recursiveReference: "Rekursiver Verweis auf {name}",
		recursive: "rekursiv",
		additionalProperties: "zusätzliche Eigenschaften",
		const: "Konstante",
		deprecated: "veraltet",
		discriminator: "Diskriminator",
		enum: "enum",
		format: "Format",
		greaterThan: "größer als",
		keys: "Schlüssel",
		lessThan: "kleiner als",
		max: "max.",
		min: "min.",
		maxLength: "max. Länge",
		minLength: "min. Länge",
		multipleOf: "Vielfaches von",
		nullable: "nullable",
		propertyNames: "Eigenschaftsnamen",
		pattern: "Muster",
		copyPattern: "Muster kopieren",
		readOnly: "nur lesbar",
		required: "erforderlich",
		hideValues: "Werte ausblenden",
		showAllValues: "Alle Werte anzeigen",
		type: "Typ",
		unique: "eindeutig",
		values: "Werte",
		writeOnly: "nur schreibbar",
		typeInteger: "Ganzzahlen.",
		formatInt32: "Vorzeichenbehaftete 32-Bit-Ganzzahlen (üblicher Ganzzahltyp).",
		formatInt64: "Vorzeichenbehaftete 64-Bit-Ganzzahlen (Typ long).",
		formatDate: "full-date-Notation gemäß RFC 3339, Abschnitt 5.6, zum Beispiel 2017-07-21",
		formatDateTime: "date-time-Notation gemäß RFC 3339, Abschnitt 5.6, zum Beispiel 2017-07-21T17:32:28Z",
		formatPassword: "Hinweis an Oberflächen, die Eingabe zu maskieren",
		formatBase64: "Base64-kodierte Zeichen, zum Beispiel U3dhZ2dlciByb2Nrcw==",
		formatBinary: "Binärdaten zur Beschreibung von Dateien"
	},
	common: {
		copyDefault: "Standardwert kopieren",
		copyExample: "Beispielwert kopieren"
	},
	actions: { copyLinkTo: "Link zu {name} kopieren" }
};
//#endregion
export { e as de };

//# sourceMappingURL=de.js.map